import {registerJQueryComponent} from '@lib/JQueryRegistry'
import NavigationBarOpenablePanel from '@lib/components/navigation-bar/NavigationBarOpenablePanel'

export default class NavigationBarNotificationsPanel extends NavigationBarOpenablePanel {
    constructor(rootElement) {
        super(rootElement, 'navigation-bar-notifications-body')
    }
}

registerJQueryComponent(NavigationBarNotificationsPanel, '.navigation-bar-notifications')